import { register, getMethod } from './register';
import rect from './rect';
import circle from './circle';
import polyline from './polyline';
import polygon from './polygon';
import text from './text';
import path from './path';
import line from './line';
import ellipse from './ellipse';
register('rect', rect);
register('image', rect); // image ä½¿ç¨ rect çåå´çè®¡ç®
register('circle', circle);
register('marker', circle); // marker ä½¿ç¨ circle çè®¡ç®æ¹æ¡
register('polyline', polyline);
register('polygon', polygon);
register('text', text);
register('path', path);
register('line', line);
register('ellipse', ellipse);
export { getMethod as getBBoxMethod };
//# sourceMappingURL=index.js.map